import * as ambassadorWixEcomV1ShippingOption from './ecom-v1-shipping-option-shipping-options.http.js';
import * as ambassadorWixEcomV1ShippingOptionTypes from './ecom-v1-shipping-option-shipping-options.types.js';
import * as ambassadorWixEcomV1ShippingOptionUniversalTypes from './ecom-v1-shipping-option-shipping-options.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createShippingOption(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1ShippingOptionUniversalTypes.CreateShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionTypes.CreateShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionUniversalTypes.CreateShippingOptionResponse &
    ambassadorWixEcomV1ShippingOptionUniversalTypes.CreateShippingOptionResponseNonNullableFields,
  ambassadorWixEcomV1ShippingOptionTypes.CreateShippingOptionResponse &
    ambassadorWixEcomV1ShippingOptionTypes.CreateShippingOptionResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippingOption.createShippingOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/shipping-options',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getShippingOption(): __PublicMethodMetaInfo<
  'GET',
  { shippingOptionId: string },
  ambassadorWixEcomV1ShippingOptionUniversalTypes.GetShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionTypes.GetShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionUniversalTypes.GetShippingOptionResponse &
    ambassadorWixEcomV1ShippingOptionUniversalTypes.GetShippingOptionResponseNonNullableFields,
  ambassadorWixEcomV1ShippingOptionTypes.GetShippingOptionResponse &
    ambassadorWixEcomV1ShippingOptionTypes.GetShippingOptionResponseNonNullableFields
> {
  const payload = { shippingOptionId: ':shippingOptionId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippingOption.getShippingOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/shipping-options/{shippingOptionId}',
    pathParams: { shippingOptionId: 'shippingOptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateShippingOption(): __PublicMethodMetaInfo<
  'PATCH',
  { shippingOptionId: string },
  ambassadorWixEcomV1ShippingOptionUniversalTypes.UpdateShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionTypes.UpdateShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionUniversalTypes.UpdateShippingOptionResponse &
    ambassadorWixEcomV1ShippingOptionUniversalTypes.UpdateShippingOptionResponseNonNullableFields,
  ambassadorWixEcomV1ShippingOptionTypes.UpdateShippingOptionResponse &
    ambassadorWixEcomV1ShippingOptionTypes.UpdateShippingOptionResponseNonNullableFields
> {
  const payload = { shippingOption: { id: ':shippingOptionId' } } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippingOption.updateShippingOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/shipping-options/{shippingOption.id}',
    pathParams: { shippingOptionId: 'shippingOptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteShippingOption(): __PublicMethodMetaInfo<
  'DELETE',
  { shippingOptionId: string },
  ambassadorWixEcomV1ShippingOptionUniversalTypes.DeleteShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionTypes.DeleteShippingOptionRequest,
  ambassadorWixEcomV1ShippingOptionUniversalTypes.DeleteShippingOptionResponse,
  ambassadorWixEcomV1ShippingOptionTypes.DeleteShippingOptionResponse
> {
  const payload = { shippingOptionId: ':shippingOptionId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippingOption.deleteShippingOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/shipping-options/{shippingOptionId}',
    pathParams: { shippingOptionId: 'shippingOptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryShippingOptions(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomV1ShippingOptionUniversalTypes.QueryShippingOptionsRequest,
  ambassadorWixEcomV1ShippingOptionTypes.QueryShippingOptionsRequest,
  ambassadorWixEcomV1ShippingOptionUniversalTypes.QueryShippingOptionsResponse &
    ambassadorWixEcomV1ShippingOptionUniversalTypes.QueryShippingOptionsResponseNonNullableFields,
  ambassadorWixEcomV1ShippingOptionTypes.QueryShippingOptionsResponse &
    ambassadorWixEcomV1ShippingOptionTypes.QueryShippingOptionsResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippingOption.queryShippingOptions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/shipping-options/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExtendedFields(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixEcomV1ShippingOptionUniversalTypes.UpdateExtendedFieldsRequest,
  ambassadorWixEcomV1ShippingOptionTypes.UpdateExtendedFieldsRequest,
  ambassadorWixEcomV1ShippingOptionUniversalTypes.UpdateExtendedFieldsResponse &
    ambassadorWixEcomV1ShippingOptionUniversalTypes.UpdateExtendedFieldsResponseNonNullableFields,
  ambassadorWixEcomV1ShippingOptionTypes.UpdateExtendedFieldsResponse &
    ambassadorWixEcomV1ShippingOptionTypes.UpdateExtendedFieldsResponseNonNullableFields
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippingOption.updateExtendedFields(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/shipping-options/{id}/update-extended-fields',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
